export default __webpack_public_path__ + "static/media/london_s.480cf6f6.jpg";